import { PUSH_STEP_ID } from 'root/src/client/logic/form/actionIds'

export default payload => ({
	type: PUSH_STEP_ID,
	payload,
})
